import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { EquipamientoProcesamiento } from '../../../entity-equipamientos-procesamiento/equipamientos-procesamiento.model';
import { Store } from '@ngrx/store';
import { State } from '../../../../vista-usuario/vista-usuario.state';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription, combineLatest } from 'rxjs';
import { selectAllTiposEquipamientoProcesamiento } from '../../../entity-tipo-equipamiento-procesamiento/tipos-equipamiento-procesamiento.selectors';
import { selectAllTiposMovilidad } from '../../../entity-tipo-movilidad/tipos-movilidad.selectors';
import { TipoEquipamientoProcesamiento } from '../../../entity-tipo-equipamiento-procesamiento/tipos-equipamiento-procesamiento.model';
import { TipoMovilidad } from '../../../entity-tipo-movilidad/tipos-movilidad.model';

@Component({
  selector: 'rpe-registro-actividad-maquinarias-moviles-form',
  templateUrl: './registro-actividad-maquinarias-moviles-form.component.html',
  styleUrls: ['./registro-actividad-maquinarias-moviles-form.component.scss'],
})
export class RegistroActividadMaquinariasMovilesFormComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = []

  @Input() equipamientosProcesamiento: EquipamientoProcesamiento = null;

  @Output() onFormChange: EventEmitter<EquipamientoProcesamiento> = new EventEmitter<EquipamientoProcesamiento>();
  @Output() onFormValid: EventEmitter<boolean> = new EventEmitter<boolean>();

  tipoEquipamientoProcesamiento: TipoEquipamientoProcesamiento[] = [];
  tiposMovilidad: TipoMovilidad[] = [];

  id: FormControl = new FormControl('');
  marca: FormControl = new FormControl('', [Validators.required]);
  modelo: FormControl = new FormControl('', [Validators.required]);
  tipo_equipamiento_procesamiento_id: FormControl = new FormControl('', [Validators.required]);
  tipo_equipamiento_procesamiento_nombre: FormControl = new FormControl('', []);

  form: FormGroup = new FormGroup({
    tipo_equipamiento_procesamiento_id: this.tipo_equipamiento_procesamiento_id,
    marca: this.marca,
    modelo: this.modelo,
    tipo_equipamiento_procesamiento_nombre: this.tipo_equipamiento_procesamiento_nombre,
  });

  constructor(
    private store: Store<State>,
  ) { }

  ngOnInit(): void {
    if (this.equipamientosProcesamiento) {
      this.form.patchValue({
        id: this.equipamientosProcesamiento.id,
        marca: this.equipamientosProcesamiento.marca,
        modelo: this.equipamientosProcesamiento.modelo,
        tipo_equipamiento_procesamiento_id: this.equipamientosProcesamiento.tipo_equipamiento_procesamiento_id,
        tipo_equipamiento_procesamiento_nombre: this.equipamientosProcesamiento.tipo_equipamiento_procesamiento_nombre,
      })
    }

    const s1 = this.form.valueChanges.subscribe((form) => {
      this.onFormChange.emit(form);
    })

    const s3 = this.form.statusChanges.subscribe((status) => {
      this.onFormValid.emit(status === 'VALID');
    })

    const s2 = combineLatest([
      this.store.select(selectAllTiposEquipamientoProcesamiento),
      this.store.select(selectAllTiposMovilidad),
    ]).subscribe(([tiposEquipamientoProcesamiento, tiposMovilidad]) => {
      this.tipoEquipamientoProcesamiento = tiposEquipamientoProcesamiento
      this.tiposMovilidad = tiposMovilidad
    })

    this.subscriptions.push(s1, s2, s3)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe())
  }
}
